import React from 'react';

function Else({children}) {
  return children;
}

Else.displayName = 'If.Else';

/**
 * Conditionally renders children or the content inside If.Else.
 *
 * @param {boolean} condition - When true, main children are rendered; when false, If.Else content is rendered.
 * @param {React.ReactNode} children - Main content when condition is true. May include an <If.Else> branch.
 *
 * @example
 * <If condition={hasCard}>
 *   <DetailsView />
 *   <If.Else>
 *     <FormView />
 *   </If.Else>
 * </If>
 */
export function If({condition, children}) {
  const childArray = React.Children.toArray(children);
  const elseChild = childArray.find(child => child?.type === Else);
  const mainChildren = elseChild
    ? childArray.filter(child => child !== elseChild)
    : childArray;

  if (condition) {
    return <>{mainChildren}</>;
  }
  if (elseChild && elseChild.props?.children != null) {
    return <>{elseChild.props.children}</>;
  }
  return null;
}

If.Else = Else;

export default If;
